import { CSSProperties } from "styled-components";

import { spacing, theme } from "../../../layout";

export const styles: Record<string, CSSProperties> = {
  wrapper: {
    position: "fixed",
    marginTop: spacing.xxs,
  },
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: 120,
    overflowY: "scroll",
    overflowX: "hidden",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
  },
  item: {
    borderBottom: `1px solid ${theme.border}`,
    width: "100%",
    textAlign: "center",
    fontFamily: `"Inter", sans-serif`,
    paddingTop: spacing.xs,
    paddingBottom: spacing.xs,
    cursor: "pointer",
    userSelect: "none",
  },
};
